// A lens to pick, in the demo's list of lenses.
.step {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 2rem;
  padding-block: 0.125rem;
  padding-inline: 0.5rem 0.25rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-card);
  font-size: 0.8125rem;
}

.step[aria-pressed="true"] {
  border-color: var(--color-primary);
  background: var(--color-primary-soft);
}

button.step {
  cursor: pointer;

  &:hover { background: var(--color-surface-raised); }
  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 2px;
  }
}

.stepIcon {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  color: var(--color-primary);

  svg {
    width: 1rem;
    height: 1rem;
  }
}

.stepLabel {
  min-width: 0;
  flex: 1;
  overflow-wrap: anywhere;
  font-weight: 500;
}
